import {HTH_INIT, HTH_SEARCH, HTH_SET_TEAM, HTH_SET_TEAMS_LIST} from "./headToHeadActions";
import {TEAM_DETAILS_INIT} from "../TeamDetails/teamDetailsActions";
import {GAMES_UPDATE} from "../LastUpdated/lastUpdatedActions";

export const headToHeadReducer = (state = {
    teamsList: [],
    columns: [],
    subleagues: [],
    subleaguesOpen: [],
    teams: {
        left: {
            search: null,
            team: null
        },
        right: {
            search: null,
            team: null
        }
    },
    show: false
}, action) => {
    switch (action.type) {
        case TEAM_DETAILS_INIT:
            return {...state, show: false};
        case HTH_INIT:
            return {
                ...state,
                columns: action.payload.columns,
                teams: teamsReducer(state.teams, action),
                subleagues: action.payload.subleagues,
                subleaguesOpen: action.payload.subleaguesOpen,
                teamsList: [],
                show: true
            };
        case HTH_SET_TEAMS_LIST:
            return {
                ...state, teamsList: [...state.teamsList, action.payload]
            };
        case GAMES_UPDATE:
            //clear cache
            return {
                ...state, teamsList: []
            };
        case HTH_SET_TEAM:
        case HTH_SEARCH:
            return {
                ...state, teams: teamsReducer(state.teams, action)
            };
        default:
            return state;
    }
};


const teamsReducer = (state = {
    left: {}, right: {}
}, action) => {
    switch (action.type) {
        case HTH_INIT:
            return {
                left: teamReducer(state[action.payload.left], action),
                right: teamReducer(state[action.payload.right], action),
            };
        case HTH_SET_TEAM:
        case HTH_SEARCH:
            return {...state, [action.payload.position]: teamReducer(state[action.payload.position], action)};
        default:
            return state;
    }
};

const teamToSportsmenIds = team => {
    let out = team.mainSquad.map(detail => detail.sportsmenId);
    if (team.substitutes) {
        return out.concat(team.substitutes.map(detail => detail.sportsmenId));
    }
    return out;
};

const teamReducer = (state = {
    search: null,
    team: null,
    sportsmenIds: null
}, action) => {
    switch (action.type) {
        case HTH_INIT:
            return {
                search: null,
                team: null
            };
        case HTH_SET_TEAM:
            return {...state, team: action.payload.team, sportsmenIds: teamToSportsmenIds(action.payload.team)};
        case HTH_SEARCH:
            return {...state, search: action.payload.teams};
        default:
            return state;
    }
};